
import { asyncLoader } from "@/router/route-helper"

export default  [
    //dashboard
    { 
        path: '/leaderboard', 
        name: 'leaderboard', 
        component: () => import('@/views/leaderboard.vue'),
        meta: { requiresAuth: true, role: 'common'},
    },
    { 
        path: '/activity-log', 
        name: 'activity-log', 
        component: () => import('@/views/activity-log/activity-log.vue'),
        meta: { requiresAuth: true, role: 'common' },
    },
    //pages
    {
        path: '/pages/error404',
        name: 'error404',
        component: () => import('@/views/pages/error404.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/change-password/:employee_id',
        name: 'change-password',
        component: () => import('@/views/users/change-password'),
        meta: { requiresAuth: true, role: 'common'},
    },
    {
        path: '/pages/error500',
        name: 'error500',
        component: () => import('@/views/pages/error500.vue'),
        meta: { layout: 'auth',  role: 'common' },
    },
    {
        path: '/pages/error503',
        name: 'error503',
        component: () => import('@/views/pages/error503.vue'),
        meta: { layout: 'auth', role: 'common' },
    },
    {
        path: '/pages/maintenence',
        name: 'maintenence',
        component: () => import('@/views/pages/maintenence.vue'),
        meta: { layout: 'auth', role: 'common' },
    },
    {
        path: '/pages/blank-page',
        name: 'blank-page',
        component: () => import('@/views/pages/blank_page.vue'),
    },
    {
        path: '/pages/sample',
        name: 'sample',
        component: () => import('@/views/pages/sample.vue'),
        meta: { layout: 'auth', role: 'common' },
    },

    //auth
    {
        path: '/auth/register-boxed',
        name: 'register-boxed',
        component: () => import('@/views/auth/register_boxed.vue'),
        meta: { layout: 'auth' , role: 'common'},
    },
    {
        path: '/change-temp-password',
        name: 'change-temp-password',
        component: () => import('@/views/auth/reset_temp_password.vue'),
        meta: { layout: 'auth', role: 'common' },
    },
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/auth/login.vue'),
        meta: { layout: 'auth', role: 'common' },
    },
    {
        path: '/forget-password',
        name: 'forget-password',
        component: () => import('@/views/auth/forget_password.vue'),
        meta: { layout: 'auth', role: 'common' },
    },
    {
        path: '/confirm-forget-password',
        name: 'confirm-forget-password',
        component: () => import('@/views/auth/confirm_forget_password.vue'),
        meta: { layout: 'auth', role: 'common' },
    },
    {
        path: '/auth/register',
        name: 'register',
        component: () => import('@/views/auth/register.vue'),
        meta: { layout: 'auth', role: 'common' },
    },
    {
        path: '/auth/lockscreen',
        name: 'lockscreen',
        component: () => import('@/views/auth/lockscreen.vue'),
        meta: { layout: 'auth', role: 'common' },
    },
];
